import { render, staticRenderFns } from "./RouteConfiguration.vue?vue&type=template&id=50203a40"
import script from "./RouteConfiguration.vue?vue&type=script&lang=js"
export * from "./RouteConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports